export const ADD_EVENT_TO_EXPERIMENT = "ADD_EVENT_TO_EXPERIMENT";
export const START_EXPERIMENT = "START_EXPERIMENT";
export const ADD_DECISION_TO_EXPERIMENT = "ADD_DECISION_TO_EXPERIMENT";